if (!customElements.get('thumbnail-slider')) {
  class ThumbnailSlider extends SliderComponent {
    constructor() {
      super();
      // TODO: Improve selector, maybe use data-attribute?
      this.modalParent = this.closest(
        'modal-dialog, modal-drawer, lookbook-modal, product-modal, quick-add-modal'
      );
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
      this.activeIndex = 0;
      this.handleThumbnailClick = this.onThumbnailClick.bind(this);
      this.debouncedControlledSlideChange = debounce(
        this.onControlledSlideChange.bind(this),
        SLIDE_CHANGE_DEBOUNCE_TIMER
      );
    }

    connectedCallback() {
      super.connectedCallback();
      this.connect();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.disconnect();
    }

    connect() {
      const target = document.getElementById(this.thumbnails[0].getAttribute('aria-controls'));
      this.controlledSliders = [target, ...target.connectedSliders];

      this.thumbnails.forEach(thumbnail =>
        thumbnail.addEventListener('click', this.handleThumbnailClick)
      );

      this.controlledSliders.forEach(slider =>
        slider.addEventListener('slideChanged', this.debouncedControlledSlideChange)
      );

      if (this.modalParent) {
        if (!this.modalParent.updateAttributes) return;

        this.modalParent.updateAttributes(true);
        this.initPages();
        this.modalParent.updateAttributes(false);
      }
    }

    disconnect() {
      this.thumbnails.forEach(thumbnail =>
        thumbnail.removeEventListener('click', this.handleThumbnailClick)
      );

      this.controlledSliders.forEach(slider => {
        slider.removeEventListener('slideChanged', this.debouncedControlledSlideChange);
      });
    }

    initPages() {
      if (!this.initialized) {
        super.initPages();
        this.initialized = true;
      }

      this.resize();
      super.initPages();
    }

    // TODO: Update with vertical orientation support (see SliderComponent)
    resize() {
      if (this.sliderItemsToShow.length === 0) return;

      this.style.removeProperty('--thumbnail-width');

      const visibleSlides = this.sliderItemsToShow.filter(slide => this.isSlideVisible(slide));
      const totalGap = this.sliderGap * (visibleSlides.length + 1);
      const thumbnailWidth = (this.offsetWidth - totalGap) / visibleSlides.length;
      this.style.setProperty('--thumbnail-width', `${thumbnailWidth}px`);
    }

    onControlledSlideChange(e) {
      if (!this.sliderItemsToShow.length || e.srcElement.isNavigating || e.srcElement.isSlave)
        return;

      const activeIndex = e.detail.currentPage - 1;

      if (activeIndex !== this.activeIndex) {
        this.setActiveThumbnail(activeIndex);
      }
    }

    onThumbnailClick(e) {
      const thumbnail = e.currentTarget;
      const index = this.thumbnails.indexOf(thumbnail);

      this.controlledSliders.forEach(slider => {
        slider.isNavigating = true;
        slider.goToSlide(index, {
          onComplete: () => {
            setTimeout(() => (slider.isNavigating = false), SLIDE_CHANGE_DEBOUNCE_TIMER);
          },
        });
      });

      this.setActiveThumbnail(index);
    }

    setActiveThumbnail(index) {
      this.activeIndex = index;
      const thumbnail = this.thumbnails[index];

      if (!thumbnail) return;

      this.thumbnails.forEach(thumbnail => thumbnail.removeAttribute('aria-current'));
      thumbnail.setAttribute('aria-current', true);

      if (this.isSlideVisible(thumbnail.closest('.slider__slide'))) return;

      this.goToSlide(index);
    }
  }

  customElements.define('thumbnail-slider', ThumbnailSlider);
}
